import { jsxs as s, jsx as n, Fragment as C } from "@emotion/react/jsx-runtime";
import { styled as Te, Box as F, Paper as we, TableContainer as ve, Table as ze, TableHead as Re, TableRow as _, TableCell as E, TableSortLabel as Ae, TableBody as De, Skeleton as _e, TablePagination as Ee, Typography as Fe, Pagination as Me, Button as j } from "@mui/material";
import { visuallyHidden as $e } from "@mui/utils";
import { useReactTable as He, getPaginationRowModel as Ne, getSortedRowModel as Be, getFilteredRowModel as Ge, getCoreRowModel as ke, flexRender as L } from "@tanstack/react-table";
import { memo as je, useState as O, useMemo as U, useEffect as T } from "react";
var Le = /* @__PURE__ */ ((o) => (o.VARIABLE_PAGE_SIZE = "Variable Page Size", o.FIXED_PAGE_SIZE = "Fixed Page Size", o.UNKNOWN_PAGE_SIZE = "Unknown page size", o))(Le || {}), Oe = /* @__PURE__ */ ((o) => (o.ROW = "row", o.PAGE = "page", o))(Oe || {});
const Ue = Te(F)({
  display: "flex",
  alignItems: "center"
}), Ze = (o = 0, r = 0, d = 50) => {
  if (o === 0)
    return {
      summaryItemsCountFrom: 0,
      summaryItemsCountTo: 0,
      summaryPageTotal: o || 0
    };
  const p = r * d + 1, h = Math.ceil(o / d), w = r + 1 === h ? o : (r + 1) * d;
  return {
    summaryItemsCountFrom: p,
    summaryItemsCountTo: w,
    summaryPageTotal: h
  };
};
function We({
  className: o,
  data: r,
  columns: d,
  isLoading: p,
  elevation: h = 1,
  globalFilter: f,
  globalFilterFn: w,
  skeletonCount: Z = 10,
  skeletonHeight: W = 28,
  pageSize: g = 10,
  pageCount: K,
  total: m = 100,
  showPagination: X = !1,
  showPaginationSummary: q = !0,
  onClickRow: v,
  compact: J = !1,
  onPaginationModelChange: b,
  onSortingChange: z,
  manualSorting: Q = !1,
  initialSort: Y = [],
  hasRowBackgroundColor: M = !0,
  isScrollable: $ = !1,
  maxHeight: V = 300,
  rowSelection: ee,
  onRowSelectionChange: te,
  noDataFoundMessage: ne = "No data found",
  columnVisibility: oe,
  manualPagination: c,
  pageSizeOptions: ae,
  paginationVariant: u = "Variable Page Size",
  paginationLabelVariant: ie = "row",
  FooterLeftElement: H,
  isTableLayoutFixed: se,
  hasPrevPage: N,
  hasNextPage: re,
  shouldResetPageIndex: B,
  autoResetPageIndex: le,
  applyRowStyles: G
}) {
  const [i, de] = O(Y), [ce, ge] = O({
    pageIndex: 0,
    pageSize: g
  }), me = U(() => d, [d]), R = U(() => r, [r]), {
    getHeaderGroups: ue,
    getRowModel: k,
    getAllColumns: pe,
    setPageIndex: he,
    getState: a,
    setPageSize: A,
    getRowCount: D,
    resetPageIndex: x
  } = He({
    data: R || [],
    columns: me,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: g
      }
    },
    state: {
      pagination: ce,
      globalFilter: f == null ? void 0 : f.trim(),
      sorting: i,
      rowSelection: ee,
      columnVisibility: oe
    },
    pageCount: K,
    enableSorting: !0,
    manualSorting: Q,
    enableSortingRemoval: !1,
    onSortingChange: de,
    getCoreRowModel: ke(),
    getFilteredRowModel: Ge(),
    getSortedRowModel: Be(),
    onRowSelectionChange: te,
    getPaginationRowModel: Ne(),
    onPaginationChange: ge,
    manualPagination: c,
    globalFilterFn: w ?? "auto",
    autoResetPageIndex: le
  }), { summaryItemsCountFrom: fe, summaryItemsCountTo: be, summaryPageTotal: xe } = Ze(
    c ? m : D(),
    a().pagination.pageIndex,
    a().pagination.pageSize
  ), Se = Array.from({ length: Z }, (t, e) => e), ye = pe().length, Pe = !p && (!R || R.length === 0 || k().rows.length < 1), Ie = (t) => {
    const e = Number(t.target.value);
    A(e), b && b({
      page: a().pagination.pageIndex,
      pageSize: e
    });
  }, S = (t) => {
    he(t), b && b({
      page: t,
      pageSize: a().pagination.pageSize
    });
  }, Ce = ({ from: t, to: e, count: l, page: y }) => {
    if (ie === "row")
      return `${t}–${e} of ${l !== -1 ? l : `more than ${e}`}`;
    const P = y + 1, I = Math.ceil(l / a().pagination.pageSize);
    return `${P} of ${I}`;
  };
  return T(() => {
    g && A(g);
  }, [g, A]), T(() => {
    z && z(i);
  }, [z, i]), T(() => {
    !m && c && x();
  }, [r, x, m, c]), T(() => {
    B && x();
  }, [r, B, x]), /* @__PURE__ */ s(we, { sx: { borderRadius: 2 }, className: o, elevation: h, children: [
    /* @__PURE__ */ s(
      ve,
      {
        sx: {
          borderBottom: M ? 1 : "none",
          borderColor: "grey.300",
          maxHeight: $ ? V : "auto"
        },
        children: [
          /* @__PURE__ */ s(
            ze,
            {
              size: J ? "small" : "medium",
              stickyHeader: $,
              sx: {
                tableLayout: se ? "fixed" : "auto"
              },
              children: [
                /* @__PURE__ */ n(Re, { "data-testid": "table-heading", children: ue().map((t) => /* @__PURE__ */ n(_, { children: t.headers.map((e) => {
                  var l, y, P, I;
                  return /* @__PURE__ */ n(
                    E,
                    {
                      style: (l = e.column.columnDef.meta) == null ? void 0 : l.style,
                      sx: (y = e.column.columnDef.meta) == null ? void 0 : y.sx,
                      children: e.isPlaceholder ? null : /* @__PURE__ */ s(
                        Ae,
                        {
                          active: ((P = i == null ? void 0 : i[0]) == null ? void 0 : P.id) === e.id,
                          direction: e.column.getIsSorted() === "asc" ? "asc" : "desc",
                          onClick: e.column.getToggleSortingHandler(),
                          hideSortIcon: !e.column.columnDef.enableSorting,
                          sx: { "& > :first-child:hover + svg": { opacity: 0 } },
                          children: [
                            L(e.column.columnDef.header, e.getContext()),
                            ((I = i == null ? void 0 : i[0]) == null ? void 0 : I.id) === e.id ? /* @__PURE__ */ n(F, { component: "span", sx: $e, children: e.column.getIsSorted() === "desc" ? "sorted descending" : "sorted ascending" }) : null
                          ]
                        }
                      )
                    },
                    e.id
                  );
                }) }, t.id)) }),
                /* @__PURE__ */ n(De, { "data-testid": "table-content", children: p ? /* @__PURE__ */ n(C, { children: Se.map((t) => /* @__PURE__ */ n(_, { children: Array.from({ length: ye }, (e, l) => l).map((e) => /* @__PURE__ */ n(E, { children: /* @__PURE__ */ n(_e, { height: W }) }, e)) }, t)) }) : k().rows.map((t) => /* @__PURE__ */ n(
                  _,
                  {
                    sx: {
                      "&:last-child td, &:last-child th": { border: 0 },
                      ...M ? {
                        "&:nth-of-type(odd)": {
                          bgcolor: "action.hover"
                        }
                      } : {},
                      ...G ? G(t) : {}
                    },
                    hover: !0,
                    children: t.getVisibleCells().map((e) => /* @__PURE__ */ n(E, { scope: "row", onClick: () => v == null ? void 0 : v(e, t), children: L(e.column.columnDef.cell, e.getContext()) }, e.id))
                  },
                  t.id
                )) })
              ]
            }
          ),
          Pe && /* @__PURE__ */ n(F, { my: 2, textAlign: "center", children: ne })
        ]
      }
    ),
    X && /* @__PURE__ */ s(
      Ue,
      {
        sx: {
          padding: 1
        },
        justifyContent: u === "Fixed Page Size" || u === "Variable Page Size" && H ? "space-between" : "flex-end",
        children: [
          u === "Variable Page Size" && /* @__PURE__ */ s(C, { children: [
            H,
            /* @__PURE__ */ n(
              Ee,
              {
                component: "div",
                count: c ? m : D(),
                page: a().pagination.pageIndex,
                rowsPerPage: a().pagination.pageSize,
                onRowsPerPageChange: Ie,
                onPageChange: (t, e) => S(e),
                rowsPerPageOptions: ae,
                labelDisplayedRows: Ce
              }
            )
          ] }),
          u === "Fixed Page Size" && /* @__PURE__ */ s(C, { children: [
            q && /* @__PURE__ */ s(Fe, { "data-testid": "pagination-navigation-label", children: [
              "Showing ",
              /* @__PURE__ */ n("b", { children: fe }),
              " to ",
              /* @__PURE__ */ n("b", { children: be }),
              " of",
              " ",
              /* @__PURE__ */ n("b", { children: c ? m : D() })
            ] }),
            /* @__PURE__ */ n(
              Me,
              {
                count: xe,
                page: a().pagination.pageIndex + 1,
                onChange: (t, e) => S(e - 1),
                variant: "outlined",
                shape: "rounded"
              }
            )
          ] }),
          u === "Unknown page size" && /* @__PURE__ */ s(C, { children: [
            /* @__PURE__ */ n(
              j,
              {
                sx: { mr: 1 },
                variant: "outlined",
                disabled: typeof N == "boolean" ? !N : a().pagination.pageIndex <= 0,
                onClick: () => S(a().pagination.pageIndex - 1),
                children: "Previous"
              }
            ),
            /* @__PURE__ */ n(
              j,
              {
                variant: "outlined",
                onClick: () => S(a().pagination.pageIndex + 1),
                disabled: re === !1,
                children: "Next"
              }
            )
          ] })
        ]
      }
    )
  ] });
}
const Ye = je(We);
export {
  Le as P,
  Ye as T,
  Oe as a,
  We as b
};
